import { InputTextarea } from "primereact/inputtextarea";
import "./suspend.scss";
import { useState } from "react";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { useQyGetEmploymentStatus } from "@core/query/employment-status.query";
import { GetResponseEmploymentStatusModel } from "@core/model/query-model-employment-status";
import { EmploymentStatusEnum } from "@core/model/employment-status.enum";
import { useQySuspendEmployeeBucket } from "@core/query/employee-bucket.query";
import { GetEmployeeBucketModel } from "@core/model/query-model-employee-bucket";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

/* eslint-disable-next-line */
export interface SuspendProps {
  bucket?: GetEmployeeBucketModel;
}

export function Suspend({ bucket }: SuspendProps) {
  const [suspendReason, setSuspendReason] = useState("");
  const [suspendId, setSuspendId] = useState("");
  const { showSuccess } = useNotificationContext();

  // QUERY GET
  const handleApiGetEmployementStatus = (
    response: GetResponseEmploymentStatusModel
  ) => {
    if (!response || !response.count || response.count <= 0) return;
    const responseData = response.data ?? [];

    if (responseData?.length === 0) {
      return;
    }

    setSuspendId(responseData[0].code);
  };
  useQyGetEmploymentStatus(
    EmploymentStatusEnum.Suspended,
    99,
    0,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    true,
    handleApiGetEmployementStatus
  );

  // QUERY SUSPEND
  const suspendApiSuccess = () => {
    showSuccess("Employee suspended");
  };
  const { mutate: suspend } = useQySuspendEmployeeBucket(suspendApiSuccess);

  const handleSuspend = () => {
    const bucketCode = bucket?.code;
    if (!suspendId || !bucketCode) {
      return new Error("No suspend or bucket ID");
    }

    confirmDialog({
      message: "Are you sure you want to suspend employee?",
      header: "Terminate Confirmation",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      accept() {
        suspend({
          code: bucket?.code,
          employment_status: suspendId,
          suspend_reason: suspendReason,
        });
      },
    });
  };

  return (
    <div id="Suspend" className="suspend">
      <h2>Employee Suspension</h2>

      <section className="mt-6 flex flex-col gap-4">
        <InputTextarea
          value={suspendReason}
          onChange={(e) => setSuspendReason(e.target.value)}
          rows={5}
          cols={30}
          placeholder="Suspension Reason"
        />
        <Button
          className="w-full block"
          label="Suspend"
          onClick={() => handleSuspend()}
        ></Button>
      </section>
    </div>
  );
}

export default Suspend;
